<template>
    <div>
        <card-header title="Sessions" icon="fa-users-class"></card-header>

        <card-toolbar>
            <button @click="$openCard('rmc-new-session', {confId: conference.id}, card)"><i class="far fa-plus"></i>New Session</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <rmc-session-tile
                    :card="card"
                    :session="session"
                    v-for="session in conference.sessions"
                    :active="(child && child.definition.component === 'rmc-session' && session.id === parseInt(child.props.sessionId))"
                    @click="$openCard('rmc-session', {confId: session.conference_id, sessionId: session.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";

    import {client as http} from '@/http_client';
    import RmcSessionTile from "../../../components/rmc/RmcSessionTile";
    import CardToolbar from "../../../TIER/components/CardToolbar";

    export default {
        components: {CardToolbar, RmcSessionTile, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: []
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
